import PropTypes from 'prop-types';
import useTranslation from 'next-translate/useTranslation';
import { Button, Col, Row } from '@arkestro/arkestro-design-system';
import { PALM } from '@utils/images';

const WAVE_STYLE = {
  height: 40,
  verticalAlign: 'bottom'
};

const WelcomeScreen = ({ setWelcomeStep }) => {
  const { t } = useTranslation('common');

  return (
    <>
      <Row>
        <Col xs={24}>
          <span className='title' style={{ marginRight: 10 }}>
            {t('onboarding.supplier.welcome_title')}
          </span>
          <img alt={t('onboarding.supplier.welcome_wave')} src={PALM} style={WAVE_STYLE} />
          <p className='subtitle' style={{ marginTop: 30 }}>
            {t('onboarding.supplier.before_you_dive_in')}
          </p>
        </Col>
      </Row>
      <Row gutter={16} justify='center' style={{ marginTop: 30 }}>
        <Col sm={12} xs={24}>
          <Button
            block
            onClick={() => setWelcomeStep({ currentWelcomeStep: 'carousel' })}
            type="primary"
          >
            {t('onboarding.supplier.lets_begin')}
          </Button>
        </Col>
      </Row>
    </>
  );
};

WelcomeScreen.propTypes = {
  setWelcomeStep: PropTypes.func.isRequired
};

export default WelcomeScreen;
